import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'

import TextInput from '@/components/ui/inputs/TextInput'
import Pagination from '@/components/ui/pagination/Pagination'

import StaffsTable, { StaffData } from '@/pages/staffs/components/StaffsTable'

export const rowsPerPageOptions = [5]

export type SelectDoctorStepProps = {
  data: StaffData[]
  isSearchingDoctors?: boolean
  onAddDoctor?: () => void
  onSearchDoctor?: (text: string) => void
  onSelectDoctor?: (doctorId: string) => void
  onPageChange?: (newPage: number, rowsPerPage: number) => void
  totalCount: number
}

export function SelectDoctorStep(props: SelectDoctorStepProps) {
  const { data, isSearchingDoctors = false, onAddDoctor, onSearchDoctor, onSelectDoctor, onPageChange, totalCount } = props
  const { t } = useTranslation()

  const [page, setPage] = useState<number>(1)

  const handleAddDoctor = () => {
    onAddDoctor?.()
  }

  const handleChangePage = (newPage: number) => {
    if (page === newPage) return
    setPage(newPage)
    onPageChange?.(newPage, rowsPerPageOptions[0])
  }

  const handleSearchDoctor = (event: React.ChangeEvent<HTMLInputElement>) => {
    onSearchDoctor?.(event.target.value)
  }

  const handleSelect = (staffData: StaffData) => {
    onSelectDoctor?.(staffData.id)
  }

  return (
    <Stack height="100%">
      <Stack direction="row" alignItems="center" p={2} spacing={2}>
        <Box sx={{ flex: 1 }}>
          <TextInput id="search-doctor" fullWidth onChange={handleSearchDoctor} placeholder={t('page.expertise.selectDoctorStep.searchDoctor.placeholder')} />
        </Box>
        <Button onClick={handleAddDoctor} variant="contained">
          {t('page.expertise.selectDoctorStep.addDoctorButton.label')}
        </Button>
      </Stack>
      <Box sx={{ flex: '1 1 auto', overflowY: 'auto' }}>
        <StaffsTable autoHightlight={false} loading={isSearchingDoctors} data={data} onSelect={handleSelect} showAction={false} />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'end', p: '10px' }}>
        <Pagination
          color="primary"
          disableChangeRowsPerPage
          itemsPerPageOptions={rowsPerPageOptions}
          shape="rounded"
          page={page}
          onPageChange={handleChangePage}
          totalItems={totalCount}
        />
      </Box>
    </Stack>
  )
}

export default SelectDoctorStep
